var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.muestraSelecccionCliente)?_c('div',{staticClass:"text-xs-center",staticStyle:{"margin-left":"8px"}},[_c('v-avatar',{staticClass:"grey data-cpointer",staticStyle:{"max-height":"40px","max-width":"40px"},on:{"click":function($event){return _vm.showMiCuenta()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("person")])],1)],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b348c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogo/ShpSeleccionCliente.vue
// module id = null
// module chunks = 